var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01855 12.3567C8.01855 13.4317 8.84355 14.2984 9.86855 14.2984H11.9602C12.8519 14.2984 13.5769 13.54 13.5769 12.6067C13.5769 11.59 13.1352 11.2317 12.4769 10.9984L9.11855 9.83171C8.46022 9.59837 8.01855 9.24004 8.01855 8.22337C8.01855 7.29004 8.74356 6.53171 9.63522 6.53171H11.7269C12.7519 6.53171 13.5769 7.39837 13.5769 8.47337M10.7919 5.41504V15.415",
    stroke: "#f9bc03",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7923 18.7482C15.3948 18.7482 19.1257 15.0174 19.1257 10.4149C19.1257 5.81238 15.3948 2.08154 10.7923 2.08154C6.18982 2.08154 2.45898 5.81238 2.45898 10.4149C2.45898 15.0174 6.18982 18.7482 10.7923 18.7482Z",
    stroke: "#f9bc03",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.388e2b3376592128a7ef18fe4767a888.svg";
export { ForwardRef as ReactComponent };